import times from 'lodash/times';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import patch from './patch';
import { getEnsuredNumericInput, getUiInput } from '../selectors/inputs';
import { computeUserFootprint } from './computeResults';

const updateElectricVehicles = (vehicle, state) =>
  reduce(
    state.user_footprint.electricVehicles,
    (o, value, n) => {
      if (parseInt(n, 10) === vehicle.index) {
        return {
          ...o,
          [n]: undefined,
        };
      }
      let index = parseInt(n, 10);
      if (parseInt(n, 10) > vehicle.index) {
        index = parseInt(n + 1, 10);
      }
      return {
        ...o,
        [index]: value,
      };
    },
    {},
  );

const updateTradeInVehicles = (vehicle, state) => [
  'electric',
  'hybrid',
  'alternativefuel',
  'more_efficient',
].reduce((tradeInVehicles, tradeInKey) => {
  if (get(state.ui, `tradeInVehicleIndices.${tradeInKey}`, 0) >= vehicle.index) {
    return {
      ...tradeInVehicles,
      [tradeInKey]: undefined,
    };
  }
  return tradeInVehicles;
}, {});

export default vehicle => (dispatch, getState) => {
  const state = getState();
  const numberVehicles = getEnsuredNumericInput(state, 'input_footprint_transportation_num_vehicles') - 1;
  const vehicleParams = times(10).reduce((params, n) => {
    const actualIndex = (n + 1 >= vehicle.index) ? (n + 2) : (n + 1);
    let miles;
    let mpg;
    let fuelType;
    if (n + 1 <= numberVehicles) {
      miles = getUiInput(state, `input_footprint_transportation_miles${actualIndex}`);
      mpg = getUiInput(state, `input_footprint_transportation_mpg${actualIndex}`);
      fuelType = getUiInput(state, `input_footprint_transportation_fuel${actualIndex}`);
    }
    return {
      ...params,
      [`input_footprint_transportation_miles${n + 1}`]: miles,
      [`input_footprint_transportation_mpg${n + 1}`]: mpg,
      [`input_footprint_transportation_fuel${n + 1}`]: fuelType,
    };
  }, {});
  const electricVehicles = updateElectricVehicles(vehicle, state);
  const tradeInVehicleIndices = updateTradeInVehicles(vehicle, state);
  dispatch(patch({
    user_footprint: { electricVehicles },
    ui: { tradeInVehicleIndices },
  }));
  computeUserFootprint({
    ...vehicleParams,
    input_footprint_transportation_num_vehicles: numberVehicles,
  })(dispatch, getState);
};
